import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';

import { ThunkAPI } from '../rootReducer';
import { basicApiAsyncThunkCreator } from '../../services/apiAsyncThunkCreator';
import { HttpMethods, SERVICES } from '../../services/api';
import { showErrorMessage, showSuccessMessage } from '../notifications';
import { getDefaultCoreUrl } from '../../components/auth/utils/getUrlToRedirect';
import { selectors } from './index';

export interface ICreateProUserPayload {
  userId: string;
  industryInternalId: string;
  industryLabel: string;
  companyRoleInternalId: string;
  companyRoleLabel: string;
  companySizeInternalId: string;
  companySizeLabel: string;
}
export const createProUser: AsyncThunk<
  void,
  ICreateProUserPayload,
  ThunkAPI
> = createAsyncThunk(
  'user/createProUser',
  async (data: ICreateProUserPayload, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<void, ICreateProUserPayload>({
        endpoint: 'users/create-pro-user',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post
      })({
        ...data
      }, thunk);
      const state = thunk.getState();
      const user = selectors.getLoggedInUser(state);
      const token = selectors.getAuthToken(state);
      const coreUrl = getDefaultCoreUrl(user?.account);
      showSuccessMessage('Account created');
      window.location.href = `${coreUrl}?token=${token}&userId=${user?.id}`;
      return response;
    } catch (error) {
      thunk.dispatch(showErrorMessage(JSON.stringify(error)));
      return thunk.rejectWithValue(error);
    }
  }
);
